'use client';

import React, { FC, ReactNode, useRef } from 'react';
import classnames from 'classnames';
import useClickOutside from '@/hooks/use-click-outside';

interface FixedCardProperty {
  isOpen?: boolean;
  bgClassName?: string; // 控制背景 top bottom left right
  contentClassName?: string; // 控制內容 top bottom left right
  contentHeight?: string; // 控制內容高度
  contentWidth?: string; // 控制內容寬度
  onClickOutside?: () => void;
  children?: ReactNode;
  isOverlayBottomNavigator?: boolean; // 是否要蓋過下方NavigatorBar
}

const FixedCard: FC<FixedCardProperty> = ({
  isOpen,
  bgClassName,
  contentClassName,
  contentHeight = 'h-full',
  contentWidth = 'w-full',
  isOverlayBottomNavigator = false,
  onClickOutside = () => {},
  children
}) => {
  const contentRef = useRef(null);
  useClickOutside(contentRef, onClickOutside);
  const overlayClassName = isOverlayBottomNavigator ? 'z-50' : 'z-10';

  return (
    <div
      className={classnames(
        'fixed h-screen w-screen bg-[#1617207f]',
        { 'bottom-[-1000px]': !isOpen },
        bgClassName,
        overlayClassName
      )}
    >
      <div
        ref={contentRef}
        className={classnames(
          'fixed left-0 shadow-bottom-navigator transition-all duration-300 will-change-transform',
          { 'bottom-[-1000px]': !isOpen },
          contentHeight,
          contentWidth,
          contentClassName
        )}
      >
        {isOpen && children}
      </div>
    </div>
  );
};

export default FixedCard;
